import { forwardRef, useEffect, useState } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { EMPTY_PARAGRAPH_HTML, replaceSlateEditorHtml } from 'src/lib/slate';

import { CustomEditable } from '../../components/CustomEditable';
import { CustomSlate } from '../../components/CustomSlate';
import { htmlToSlate } from '../../lib';
import { useRichSlateEditor } from '../../useRichSlateEditor';

import { useStyles } from './useStyles';

const propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({}),
  html: PropTypes.string,
  placeholder: PropTypes.string,
};
const defaultProps = {
  className: '',
  classes: null,
  html: '',
  placeholder: '',
};

export const ReadonlyHtmlEditor = forwardRef(
  ({ className, classes, html, placeholder, ...restProps }, ref) => {
    const styles = useStyles({ classes });

    const editor = useRichSlateEditor();
    const [initialValue] = useState(() =>
      htmlToSlate(html ? wrapSpansInParagraph(html) : EMPTY_PARAGRAPH_HTML)
    );

    useEffect(() => {
      replaceSlateEditorHtml(editor, wrapSpansInParagraph(html));
    }, [editor, html]);

    return (
      <div
        className={cx(styles.root, className)}
        ref={ref}
        {...restProps}
      >
        <CustomSlate
          editor={editor}
          initialValue={initialValue}
        >
          <CustomEditable
            className={styles.editable}
            placeholder={placeholder}
            readOnly
          />
        </CustomSlate>
      </div>
    );
  }
);

ReadonlyHtmlEditor.displayName = 'ReadonlyHtmlEditor';
ReadonlyHtmlEditor.propTypes = propTypes;
ReadonlyHtmlEditor.defaultProps = defaultProps;

const wrapSpansInParagraph = (html) => {
  // Trim spaces/newlines
  const trimmed = html.trim();

  // Regex: does the string consist of only spans (possibly with whitespace in between)?
  const onlySpans = /^(\s*<span\b[^>]*>[\s\S]*?<\/span>\s*)+$/.test(trimmed);

  if (onlySpans) {
    return `<p>${trimmed}</p>`;
  }
  return html;
};
